<template>
	<div
		class="g-block-body-split-header g-block-body-padding"
		:class="{
			'g-block-body-split-header--edit': editable,
			'is-active': editable && active,
			'g-block-body-split-header--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-body-split-header__card">
			<div
				class="g-block-body-split-header__head"
				:style="{ background: themeColor }"
			>
				<RichTextEditable
					v-if="editable"
					class="g-block-body-split-header__title"
					fit-content
					:model-value="data.title"
					placeholder="请输入标题"
					@update:model-value="onTitleUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-body-split-header__title"
					v-html="data.title || ''"
				></div>
			</div>
			<div
				class="g-block-body-split-header__body"
				:style="{ background: bodyBackground }"
			>
				<RichTextEditable
					v-if="editable"
					class="g-block-body-split-header__text"
					:model-value="data.content"
					placeholder="请输入正文"
					@update:model-value="onContentUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-body-split-header__text"
					v-html="data.content || ''"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { lightenHexColor } from '../../../utils/richText.js';
	import { bodyCardMixin } from '../shared/bodyCardMixin.js';

	export default {
		name: 'GBlockBodySplitHeader',
		components: { RichTextEditable },
		mixins: [bodyCardMixin],
		computed: {
			bodyBackground() {
				return lightenHexColor(this.themeColor, 0.93);
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';

	.g-block-body-split-header {
		.body-block-edit-shell();
	}

	.g-block-body-split-header__card {
		border-radius: 8px;
		overflow: hidden;
		box-shadow: 0 0 0 1px #eceef2;
	}

	.g-block-body-split-header__head {
		padding: 12px 14px;
	}

	.g-block-body-split-header__title {
		.body-title-base();
		color: #fff;
		text-align: center;

		:deep(.g-rich-text-editable__content) {
			color: #fff;
			text-align: center;
		}
	}

	.g-block-body-split-header__body {
		padding: 12px 14px;
	}

	.g-block-body-split-header__text {
		.body-text-base();
	}

	.g-block-body-split-header--h5 {
		.g-block-body-split-header__card { border-radius: 0.16rem; }
		.g-block-body-split-header__head,
		.g-block-body-split-header__body { padding: 0.24rem 0.28rem; }
		.body-title-base--h5(~'.g-block-body-split-header__title');
		.body-text-base--h5(~'.g-block-body-split-header__text');
	}
</style>
